import { DATE_FORMAT_LONG, gqlIsoDateFormat, paymentAmountFormat } from '@willow/shared-web';

import { PortalSelectedLoan } from '../../../App';
import { AlertWrapper } from './AlertWrapper';

export const ActiveWorkoutPlanAlert = ({
  activeWorkoutPlan,
  totalAmountDueForWorkoutPlan,
}: {
  activeWorkoutPlan: PortalSelectedLoan['currentSnapshot']['activeWorkoutPlan'] | undefined;
  totalAmountDueForWorkoutPlan: number | undefined;
}) => {
  if (!activeWorkoutPlan) return null;
  return (
    <>
      {activeWorkoutPlan.type === 'FLEX_MODIFICATION' && (
        <AlertWrapper
          title="Active trial flex modification in place"
          subtitle={`${paymentAmountFormat(totalAmountDueForWorkoutPlan ?? 0)} plan payment due`}
          level="ERROR"
        />
      )}

      {activeWorkoutPlan.type === 'FORBEARANCE' && (
        <AlertWrapper
          title="Active forbearance in place"
          subtitle={`Forbearance ends on ${gqlIsoDateFormat(activeWorkoutPlan.endDate, DATE_FORMAT_LONG)}`}
          level="ERROR"
        />
      )}

      {activeWorkoutPlan.type === 'REPAYMENT_PLAN' && (
        <AlertWrapper
          title="Active repayment plan in place"
          subtitle="Loan is current when repayments are completed"
          level="ERROR"
        />
      )}
    </>
  );
};
